exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-radio-button {\n  margin-right: 15px; }\n\nmat-checkbox {\n  text-align: center; }\n\n.facturation {\n  padding: 15px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/societe/societe.component.scss
// module id = ../../../../../src/app/components/societe/societe.component.scss
// module chunks = main